/* Hania speed (Oct 2026): tiny stand-ins so main.js keeps working on pages
   where the heavy filter plugins (bootstrap-select 100KB, noUiSlider 41KB) are not loaded. */
(function () {
  var $ = window.jQuery;
  if ($ && $.fn && !$.fn.selectpicker) { $.fn.selectpicker = function () { return this; }; }
  if (!window.noUiSlider) {
    window.noUiSlider = { create: function () { return { on: function () {}, set: function () {}, get: function () { return [0, 0]; }, destroy: function () {} }; } };
  }
})();
